export enum TitleListLayout {
	GRID = 'Grid',
	ROW = 'Row',
	CARD = 'Card',
}
